export default __webpack_public_path__ + "static/media/icon_category-real-estate.3e960feb.svg";